/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authApiKeysCreate } from "../../funcs/authApiKeysCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateScopedApiKeyRequest$inboundSchema,
};

export const tool$authApiKeysCreate: ToolDefinition<typeof args> = {
  name: "auth-api-keys-create",
  description: `Mint a scoped API key

Mint an API key bound to a (principal, team) carrying an explicit scope set. Requires a session, or a bearer key holding \`write:apikeys\`. The plaintext secret is returned once.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authApiKeysCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
